import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { TRANSFER_LINK_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import { TransferLinkRequest, TransferLinkResponse } from './types';

export function useTransferLinkMutationApi(id: string) {
  return useBaseMutation<TransferLinkRequest, TransferLinkResponse>({
    url: `${TRANSFER_LINK_ROOT_ENDPOINT}/${id}`,
    method: HttpMethod.put,
    params: {
      action: 'accept',
    },
  });
}
